<template>
  <div :style="themeStyle" height="100%" style="background-color:#F2F2F2">
    <v-row class=" p-3" :style="isTargetShop ? 'background-color: #ffa300' : $bgColor" no-gutters>
      <v-col cols="12"> <v-icon @click="$router.go(-1)" style="cursor: pointer;">mdi-chevron-left</v-icon> ของรางวัล </v-col>
    </v-row>
    <v-container class="pt-5" v-if="!item" height="50%"  style="background-color:#F2F2F2">
       <v-skeleton-loader height="50vh"
          type="card"
        ></v-skeleton-loader>
    </v-container>
    <div v-if="item" height="100%"  style="background-color:#F2F2F2">
      <!-- <h1>socket Example with Vue.js</h1>
      <v-btn @click="sendMessage">Send Message</v-btn> -->
      <div class="mx-auto rounded-lg" elevation="2" height="100%">
        <v-img class="white--text align-end" :src="item.pictureUrl">
          <div
            v-if="item.quotaCode <= 0"
            style="
              position: absolute;
              left: 0px;
              top: 45px;
              text-align: center;
              color: #fff;
              background-color: red;
              width: 100px;
              border-style: solid;
              border-color: #fff;
              border-width: 2px;
              border-left-style: none;
            "
          >
          {{ $t("message.outStock") }}
          </div>
          <v-chip
            class="ma-2"
            color="white"
            style="position: absolute; bottom: 20px; right: 5px"
            :style="$isTargetShop ?' background-color: #ffa300 !important' : '' "
          >

              <div v-if="item.supply !== 'admin'">
                <div v-if="item.resale && item.resale > 0">
                  <strong v-if="item.resale" class="text-center"
                      >{{item.resale}}
                  </strong>
                  <strong class="text-center" color="#181446" style="text-decoration: line-through;color: grey;margin-left: 4px;font-size: 13px;"
                    >{{ formatNumber(item.point) }}
                  </strong>
                </div>
                <div v-else>
                  <strong class="text-center" color="#181446"
                    >{{ formatNumber(item.point) }}
                  </strong>
                </div>
              </div>
              <div v-else>
                <strong class="text-center" color="#181446"
                  >{{ findPointToRedeem(item.levelSettingsReward) }}
                </strong>
              </div>
               <img
                  v-if="profile && profile.pictureUrl && !isTargetShop"
                  style="
                    border-color: white;
                    height: 20px;
                    margin-right: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
            <img
                v-else
                style="
                  border-color: white;
                  height: 20px;
                  margin-right: 4px;
                "
                alt="Avatar"
                class="ms-1"
                :src="$images.ChubbIconReward"
              />
          </v-chip>
        </v-img>
        <v-container fluid>
          <v-row v-if="$i18n.locale === 'th' || item.nameEng === '' || item.nameEng === null">
            <v-col class="bold font18">{{ item.name }}</v-col>
          </v-row>
          <v-row v-if="$i18n.locale === 'en' && item.nameEng !== null && item.nameEng !== ''">
            <v-col class="bold font18">{{ item.nameEng }}</v-col>
          </v-row>
          <v-row>

            <v-chip class="ma-2" color="#ffa300" text-color="#000" small>
              <span v-if="item.levelNm === 'All Level' || !item.levelId">สำหรับสมาชิกทุกระดับ</span>
              <span v-else> {{ checkLevel(item.levelId) }} </span>
              <img
                style="
                  border-color: white;
                  height: 20px;
                  margin-left: 4px;
                "
                alt="Avatar"
                :src="$images.ChubbIconReward"
              />
            </v-chip>
            <v-chip class="ma-2" color="#ffa300" text-color="#000" small>
              <div v-if="item.supply === 'จัดส่ง'">{{ $t("message.delivery") }}</div>
              <div v-if="item.supply === 'รับหน้าร้าน'">{{ item.shopId === 'U2ad4ca7a5c84fbe7358b56f54af919fa' ? 'รับที่สำนักงานโครงการ' : $t("message.ReceiveAtStore") }}</div>
              <div v-if="item.supply === 'link_code'">{{ item.supply }}</div>
              <div v-if="item.supply === 'admin'">{{ item.supply }}</div>
              <!-- {{ (item.supply === 'จัดส่ง' ? {{ $t("message.inventories") }} : ) }} -->
              <v-icon right small>
                {{
                  item.supply === "จัดส่ง"
                    ? "mdi-cube-send"
                    : item.supply === "รับหน้าร้าน"
                    ? "mdi-store"
                    : item.supply === "link_code"
                    ? "mdi-barcode-scan"
                    : "mdi-comment-account"
                }}
              </v-icon>
            </v-chip>
            <v-chip class="ma-2" color="#ffa300" text-color="#000" small>
              {{ $t("message.inventories") }} <p style="margin-bottom:0px;padding-left:5px">{{ item.quotaCode }}</p>
            </v-chip>
            <v-chip class="ma-2" color="#ffa300" text-color="#000" small>
              {{ $t("message.visiter") }} <p style="margin-bottom:0px;padding-left:5px">{{ item.countView }}</p>
              <v-icon right small>mdi-eye</v-icon>
            </v-chip>
          </v-row>
          <v-row v-if="item.description && $i18n.locale === 'th' || item.descriptionEng === '' || item.descriptionEng === null">
            <v-col class="icon2 font14"
              ><nl2br tag="p" :text="item.description"
            /></v-col>
          </v-row>
          <v-row v-if="item.descriptionEng && $i18n.locale === 'en'">
            <v-col class="icon2 font14"
              ><nl2br tag="p" :text="item.descriptionEng"
            /></v-col>
          </v-row>
        </v-container>

        <div class="px-5" style="margin-bottom: 20px;">
          <v-btn
            v-if="item.quotaCode > 0"
            class="rounded-md"
            :color='$isTargetShop ? "#ffa300" : $bgColor'
            dark
            block
             flat
            title
            :disabled="item.supply === 'admin'"
            :style="{'color': $CUSTOMMainTextColor, 'border-radius': $isTargetShop ? '0px' : '', 'box-shadow': $isTargetShop ? 'none' : ''}"
            :loading="load"
            @click="checkLevelAndCoin()"
          >
          <b>{{ $t("message.redeemReward") }}</b>
          </v-btn>
          <v-btn
            v-if="item.quotaCode <= 0"
            disabled
            class="rounded-lg"
            :color='$isTargetShop ? "#ffa300" : $bgColor'
            rounded
            block
            flat
            title
            :style="{'color': $CUSTOMMainTextColor, 'border-radius': $isTargetShop ? '0px' : '', 'box-shadow': $isTargetShop ? 'none' : ''}"
            @click="checkLevelAndCoin()"
          >
          <b>{{ $t("message.outStock") }}</b>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'RewardDetail',
  sockets: {
    connect () {
    }
  },
  data () {
    return {
      id: this.$route.params.id,
      item: null,
      // socket: io(),
      member: null,
      profile: { userId: '', displayName: '', pictureUrl: '', statusMessage: '', memberId: '' },
      message: null,
      msgList: [],
      msg: '',
      isConnected: null,
      load: false,
      shopData: null,
      levelName: null,
      levels: []
    }
  },
  computed: {
    shopId () {
      return this.member && this.member.shopId ? this.member.shopId : null
    },
    isTargetShop () {
      return this.$isTargetShop()
    }
  },
  async mounted () {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getLevelsByShop()
    await this.getReward()
    await this.transactionVisitPage()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    checkLevel (levelId) {
      if (!levelId || this.levels.length === 0) {
        return this.$t('message.allLevels')
      }
      const level = this.levels.find(l => l.levelId === levelId)
      return level ? level.name : this.$t('message.allLevels')
    },

    findPointToRedeem (item) {
      try {
        const levelSettings = JSON.parse(item)
        if (Array.isArray(levelSettings)) {
          const matched = levelSettings.find(data =>
            data.levelId.toString() === this.member.levelId && data.enabled === true
          )
          return matched ? matched.points : null
        }

        return null
      } catch (error) {
        console.error('findPointToRedeem error', error)
      }
    },
    async checkLevelAndCoin () {
      if (this.item.levelNm === 'All Level') {
        if (this.member.currentPoint >= this.item.point) {
          if (this.item.supply === 'จัดส่ง') {
            this.$router.push(`/reward/addAddress/${this.item.rewardId}`)
          } else {
            this.load = await this.redeemReward(this.item)
            this.member = this.GET_MEMBERINFO()
          }
        } else if (this.member.currentPoint < this.item.point) {
          // await this.redeemReward(this.item)
          Swal.fire({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            icon: 'error',
            width: 3000,
            title: 'คะแนน ของคุณไม่พอ  :( ',
            html: 'คุณต้องการไป ดูเงื่อนไขรับคะแนนหรือไม่ ?',
            backdrop: `rgba(0,0,001,0.4)`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/HowToGetCoin')
            } else {
              this.load = false
            }
          })
        }
      } else if (this.item.levelNm !== 'All Level') {
        // console.log(' not All Level', this.item)
        // console.log('this.member', this.member)
        if (this.member.levelPoint >= this.item.levelPoint) {
          if (this.member.currentPoint >= this.item.point) {
            if (this.item.supply === 'จัดส่ง') {
              this.$router.push(`/reward/addAddress/${this.item.rewardId}`)
            } else {
              this.load = await this.redeemReward(this.item)
              this.member = this.GET_MEMBERINFO()
            }
          } else if (this.member.currentPoint < this.item.point) {
            Swal.fire({
              toast: true,
              position: 'center',
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonColor: '#6ECB63',
              confirmButtonText: 'ยืนยัน',
              cancelButtonText: 'ยกเลิก',
              icon: 'error',
              width: 3000,
              title: 'คะแนน ของคุณไม่พอ  :( ',
              html: 'คุณต้องการไป ดูเงื่อนไขรับคะแนนหรือไม่ ?',
              backdrop: `rgba(0,0,001,0.4)`
            }).then((confirm) => {
              if (confirm.isConfirmed) {
                this.$router.push('/HowToGetCoin')
              } else {
                this.load = false
              }
            })
          }
        } else if (this.member.levelPoint < this.item.levelPoint) {
          Swal.fire({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: 'ตกลง',
            icon: 'error',
            width: 3000,
            title: 'ระดับบัตรสมาชิกไม่พอ :(',
            html:
              'สามารถเเลกได้เฉพาะ member ที่มีเลเวล ' +
              this.item.levelNm +
              ' ขึ้นไปเท่านั้น',
            backdrop: `rgba(0,0,001,0.4)`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/tierBenefit')
            }
          })
        }
      }
    },
    async getReward () {
      const result = await this.callBeTaskAPI(
        'get',
        `/reward/getColor?rewardId=${this.id}`
      )
      if (result) {
        this.item = result[0]
        // หาชื่อ level จาก levelId
        if (this.item.levelId && this.levels.length > 0) {
          const level = this.levels.find(l => l.levelId === this.item.levelId)
          if (level) {
            this.levelName = level.name
          }
        }
      }
    },
    async getLevelsByShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/level/line/get?RECORD_STATUS=N`
      )
      if (result) {
        this.levels = result
      }
    },
    async transactionVisitPage () {
      const result = await this.callBeTaskAPI(
        'post',
        `/TransactionVisitPage/add`, {
          page: 'Reward Detail',
          rewardId: this.id,
          shopId: this.member.shopId,
          CREATE_USER: this.member.lineUserId
        }
      )
      if (result) {
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Reward/Detail.vue